import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import {
  fetchAllProjects,
} from "../../../store/slices/projectsSlice";
import { acceptOperationAction, rejectOperationAction } from "../../../store/slices/operationActionSlice";
import useToolGuideSync from "../../../features/toolGuide/useToolGuideSync";
import { MANAGER_BUCKET_KEYS } from "../../../features/toolGuide/toolGuideConfig";

const ActionsOP = ({
  handleProjectread,
  project,
  index,
  SetisLoading,
  SetShowprojectDetails,
  setselectedproject,
  setAcceptedProject,
  setOpenDetailsIdx,
  setServiceofuser,
  setAction,
  setselectedprojectid,
  setSelected,
  selected,
  employees,
  handlerefresh,
  showprojectDetails,
  isViewOnly = false
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { syncToolGuideStep } = useToolGuideSync(
    MANAGER_BUCKET_KEYS.PROJECT_REQUESTS,
    "L4_OPS"
  );
  const [openProbabilityIndex, setOpenProbabilityIndex] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const role = localStorage.getItem("Roles");

  const dropdownRefsProbability = useRef([]);
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openProbabilityIndex === index &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpenProbabilityIndex(null);
      }
    };

    // Update dropdown position on scroll/resize when open
    const updatePosition = () => {
      if (openProbabilityIndex === index && buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        setDropdownPosition({
          top: rect.bottom,
          left: rect.left
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", updatePosition, true);
    window.addEventListener("resize", updatePosition);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", updatePosition, true);
      window.removeEventListener("resize", updatePosition);
    };
  }, [openProbabilityIndex, index]);

  const handleAcceptProject = async (index, project) => {
    if (isViewOnly) return;
    SetisLoading(true);
    const email = localStorage.getItem("email");

    const isUserAssigned = project.Assignedperson?.find(
      person => person.email === email // replace with your actual logged user email variable
    );
    // If already accepted or manager action is complete, just open in view mode.
    // Do not block accept based on taskStatus so "submit" users can still accept/reject.
    if (isUserAssigned?.operationaction === "accept" || isUserAssigned?.manageraction === "complete") {
      syncToolGuideStep("fill-details");
      await handleProjectread(project)
      SetisLoading(false);
      return
    }
    syncToolGuideStep("accept");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const projectid = project?._id
    const userid = currentEmployee?._id
    try {
      await dispatch(acceptOperationAction({ projectid, userid }));
      await handleProjectread(project)
      if (isUserAssigned?.operationaction !== "accept") {
        enqueueSnackbar("Project Accepted Successfully", {
          variant: "success",
        });
      }
      dispatch(fetchAllProjects());
    } catch (error) {
      console.error("Failed to reject Project:", error);
    } finally {
      setOpenProbabilityIndex(null);
      dispatch(fetchAllProjects());
      SetShowprojectDetails(false);
      handlerefresh()
      SetisLoading(false);
    }
  };

  const handleRejectProject = async (index, project) => {
    if (isViewOnly) return;
    syncToolGuideStep("reject");
    const email = localStorage.getItem("email");
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const projectid = project?._id
    const userid = currentEmployee?._id
    SetisLoading(true);
    try {
      await dispatch(rejectOperationAction({ projectid, userid }));
      enqueueSnackbar("Project Rejected Successfully", { variant: "success" });
      dispatch(fetchAllProjects());
    } catch (error) {
      console.error("Failed to reject Project:", error);
    } finally {
      SetShowprojectDetails(false);
      setOpenDetailsIdx(null);
      setOpenProbabilityIndex(null)
      SetisLoading(false);
      dispatch(fetchAllProjects());
      handlerefresh()
      setselectedprojectid("")
    }
  };

  const person = project.Assignedperson.find(
    (p) => p.email === localStorage.getItem("email")
  );
  return (
    <div>

      {
        role === "project manager" ? (
          <div className="p-1">
            <div
              type="button"
              onClick={() => {
                if (isViewOnly) return;
                handleAcceptProject(index, project);
                syncToolGuideStep("fill-details");
                SetShowprojectDetails(true);
                setselectedproject(project.ProjectName);
                setselectedprojectid(project._id);
                setServiceofuser(project.TypeService);
                setAcceptedProject(project);
                setOpenProbabilityIndex(openProbabilityIndex === null);
                setOpenDetailsIdx(index);
                dispatch(fetchAllProjects());
                setSelected(!selected)
              }}
              className={`${isViewOnly ? "cursor-not-allowed pointer-events-none bg-[#e5e7eb] text-[#9ca3af]" : "cursor-pointer bg-white"}
            drop btn min-w-32 max-w-36 
            relative flex items-center p-1 py-2  truncate break-words justify-center border border-gray-400 text-nowrap rounded-md
              shadow-md text-sm overflow-hidden text-ellipsis "`}
            >
              View
            </div>
          </div>
        ) : (
          <div className="relative bg-white w-full flex justify-center align-middle items-center">
            <div
              ref={(el) => (dropdownRefsProbability.current[index] = el)}
              className="relative flex items-center "
            >

              <div
                ref={buttonRef}
                type="button"
                onClick={() => {
                  if (isViewOnly) return;
                  const person = project.Assignedperson.find(
                    (p) => p.email === localStorage.getItem("email")
                  );
                  if (person?.operationaction === "reject") return;
                  
                  if (buttonRef.current) {
                    const rect = buttonRef.current.getBoundingClientRect();
                    setDropdownPosition({
                      top: rect.bottom,
                      left: rect.left
                    });
                  }
                  
                  setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
                }}
                className={`${isViewOnly ? "cursor-not-allowed pointer-events-none bg-[#e5e7eb] text-[#9ca3af]" : person?.operationaction === "reject" ? "cursor-not-allowed" : "cursor-pointer"} 
            drop btn min-w-32 max-w-36 
            relative flex items-center p-1 py-2  truncate break-words justify-between border border-gray-400 text-nowrap rounded-md
              shadow-md text-sm overflow-hidden text-ellipsis ${isViewOnly ? "" : "bg-white"} "`}
              >
                <span className="w-full text-xs truncate break-words">
                  {(() => {
                    const person = project.Assignedperson.find(
                      (p) => p.email === localStorage.getItem("email")
                    );
                    if (person?.operationaction === "reject") return "Rejected";
                    if (person?.operationaction === "accept") return "Accepted";
                    if (person?.manageraction === "reassign") return "Reassign";
                    if (person?.manageraction === "review") return "Review";

                    return "Select Option";
                  })()}
                </span>

                <ExpandMoreIcon
                  className={`absolute right-0 text-gray-500 ${isViewOnly ? "bg-[#e5e7eb]" : "bg-white"}`}
                  onClick={() => {
                    if (isViewOnly) return;
                    const person = project.Assignedperson.find(
                      (p) => p.email === localStorage.getItem("email")
                    );
                    if (person?.operationaction === "reject") return;
                    
                    if (buttonRef.current) {
                      const rect = buttonRef.current.getBoundingClientRect();
                      setDropdownPosition({
                        top: rect.bottom,
                        left: rect.left
                      });
                    }
                    
                    setOpenProbabilityIndex(openProbabilityIndex === index ? null : index);
                  }}
                />
              </div>

              {openProbabilityIndex === index && (
                <div 
                  ref={dropdownRef}
                  className="dropdown fixed p-1 z-[9999] bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                  style={{
                    top: `${dropdownPosition.top}px`,
                    left: `${dropdownPosition.left}px`,
                    width: buttonRef.current ? `${buttonRef.current.offsetWidth}px` : 'auto',
                    minWidth: '8rem'
                  }}
                >
                  {(() => {
                    const person = project.Assignedperson.find(
                      (person) => person.email === localStorage.getItem("email")
                    );
                    const action = person?.operationaction;
                    if (action === "reject") return null;
                    return (
                      <div
                        className={`p-1 ${isViewOnly ? "cursor-not-allowed pointer-events-none bg-[#e5e7eb] text-[#9ca3af]" : "cursor-pointer hover:bg-gray-100"}`}
                        onClick={() => {
                          if (isViewOnly) return;
                          const isOpening = !showprojectDetails;
                          handleAcceptProject(index, project);
                          if (isOpening) {
                            syncToolGuideStep("fill-details");
                          }
                          SetShowprojectDetails(!showprojectDetails);
                          setselectedproject(project.ProjectName);
                          setselectedprojectid(prev => prev === project._id ? null : project._id)
                          setServiceofuser(project.TypeService);
                          setAcceptedProject(project);
                          setOpenProbabilityIndex(openProbabilityIndex === null);
                          setOpenDetailsIdx(index);
                          dispatch(fetchAllProjects());
                          setSelected(!selected)
                        }}
                      >
                        {action === "accept" ? "View" : "Accept"}
                      </div>
                    );
                  })()}

                  <div
                    className={`p-1 ${isViewOnly ? "cursor-not-allowed pointer-events-none bg-[#e5e7eb] text-[#9ca3af]" : "cursor-pointer hover:bg-gray-100"}`}
                    onClick={() => {
                      if (isViewOnly) return;
                      handleRejectProject(index, project);
                    }}
                  >
                    Reject
                  </div>
                </div>
              )}
            </div>
            <div className="absolute right-1">
              {project.Assignedperson?.[0]?.taskStatus === "Submit" && (
                <div>✅</div>
              )}
            </div>
          </div >
        )}

    </div >
  );
};

export default ActionsOP;
